import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Html5Qrcode, Html5QrcodeSupportedFormats} from "html5-qrcode";
import useDidMountEffect from "utils/useDidMountEffect";
import useAfterUpdateEffect from "utils/useAfterUpdateEffect";
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";

const qrcodeRegionId = "html5qr-code-full-region";

let html5Qrcode;
const CodeCameraScanner = ({ qrCodeSuccessCallback }) => {
  const [cameraId, setCameraId] = useState(localStorage.cameraId ?? undefined)
  const [devicesAllow, setDevicesAllow] = useState()
  const [displayDevicesAllowMsg, setDisplayDevicesAllowMsg] = useState(false)
  const [devices, setDevices] = useState([])

  useEffect(() => {
    setTimeout(() => {
      setDisplayDevicesAllowMsg(true)
    }, 500)
    if(cameraId){
      setTimeout(() => {
        startScanner()
      }, 300)
    }
    return () => stopScanner()
  }, [])

  useAfterUpdateEffect(() => {
    if(cameraId){
      stopScanner()
      localStorage.setItem('cameraId', cameraId)
      setTimeout(() => {
        startScanner()
      }, 10)
    }
  }, [cameraId])

  useDidMountEffect(() => {
    html5Qrcode = new Html5Qrcode(qrcodeRegionId, {
      formatsToSupport: [
        Html5QrcodeSupportedFormats.QR_CODE,
        Html5QrcodeSupportedFormats.CODE_39,
        Html5QrcodeSupportedFormats.CODE_93,
        Html5QrcodeSupportedFormats.CODE_128,
        Html5QrcodeSupportedFormats.ITF,
        Html5QrcodeSupportedFormats.EAN_13,
        Html5QrcodeSupportedFormats.EAN_8,
        Html5QrcodeSupportedFormats.PDF_417,
        Html5QrcodeSupportedFormats.RSS_14,
        Html5QrcodeSupportedFormats.RSS_EXPANDED,
        Html5QrcodeSupportedFormats.UPC_A,
        Html5QrcodeSupportedFormats.UPC_E,
      ]
    })

    Html5Qrcode.getCameras()
      .then(devices => {
        setDevices(devices)
        setDevicesAllow(true)
        if(devices.length > 0 && !cameraId){
          setCameraId(devices[0].id)
        }
      })
      .catch(res => {
        setDevicesAllow(false)
      })
  })

  const stopScanner = () => {
    if(html5Qrcode?.getState() === 2){
      html5Qrcode.stop()
    }
  }

  const startScanner = () => {
    html5Qrcode.start(
      cameraId,
      {
        fps: 10,
        qrbox: { width: Math.min(window.innerWidth, window.innerHeight) * 0.65, height: Math.min(window.innerWidth, window.innerHeight) * 0.65 },
      },
      qrCodeSuccessCallback,
      (errorMessage) => {
        // parse error, ignore it.
      }
    )
  }

  return (
    <div className="w-100">
      {devices.length > 1 && <select className="form-select form-select-sm mb-2" onChange={e => setCameraId(e.target.value)} value={cameraId}>
        {devices.map((device, key) => <option key={key} value={device.id}>{device.label}</option>)}
      </select>}
      {
        devicesAllow === undefined && (displayDevicesAllowMsg ? <div className="alert alert-info text-center">Wyraź zgodę na dostęp do kamery na tym urządzeniu</div> : <LoadingSpinner />)
      }

      {devicesAllow === false && <div className="alert alert-danger text-center">Brak zgody na dostęp do kamery na tym urządzeniu</div>}
      <div id={qrcodeRegionId}  width="600px" height="600px" />
    </div>
  );
};

CodeCameraScanner.propTypes = {
  qrCodeSuccessCallback: PropTypes.func.isRequired,
};

export default CodeCameraScanner;